import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the stripe payouts list with pagination
   * @param {any} query - The query
   */
  fetchStripePayouts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout`, {
      ...parameters,
    });
  },
  /**
   * Fetch the stripe payouts list filters
   */
  fetchStripePayoutsListFilters: (): Promise<any> => {
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout/list-filters`);
  },
  /**
   * Export stripe payouts data
   * @param {any} query - The query
   */
  exportStripePayouts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.transactionApiUrl}api/super-admin/v1/revenue-payout/export-data`, {
      ...parameters,
    });
  },
  /**
   * Approve stripe payouts
   * @param {any} id - The payout ID to approve
   * @returns {any} A promise that resolves with the approval response
   */
  approveStripePayouts: (id: string): Promise<any> => {
    return postRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/transfer/${id}`,
      {},
    );
  },
  /**
   * Reject stripe payouts
   * @param {any} id - The payout ID to reject
   * @returns {any} A promise that resolves with the rejection response
   */
  rejectStripePayouts: (id: string): Promise<any> => {
    return postRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/reject/${id}`,
      {},
    );
  },
  /**
   * stripe payouts pending counts
   * @param {any} query - The query
   */
  fetchStripePendingCount: (query: QueryParameters = {}): Promise<any> => {
    const parameter = { ...query };
    return getRequest(
      `${config.transactionApiUrl}api/super-admin/v1/revenue-payout/pending-count`,
      { ...parameter },
    );
  },
};
